/* eslint-disable prettier/prettier */
import t from '../labels/labelling-utils';

export const tournamentPhasesMap: Record<string, string> = {
  // Qualifying
  'Qualifying 1st Round': t('tennis.qualification.r1'),
  'Qualifying 2nd Round': t('tennis.qualification.r2'),
  'Qualifying 3rd Round': t('tennis.qualification.r3'),
  'Qualifying Final': t('tennis.qualification.final'),
  // Main Phases
  '1/128 Final': t('tennis.round.128'),
  '1/64 Final': t('tennis.round.64'),
  '1/32 Final': t('tennis.round.32'),
  '1/16 Final': t('tennis.round.16'),
  'Quarter Finals': t('tennis.quarter.finals'),
  'Semi Finals': t('tennis.semifinals'),
  '3rd Place': t('tennis.3rd.place'),
  'Final': t('tennis.final'),
  'Group Stage': t('tennis.group.stage'),
  'Play-offs': t('tennis.playoff'),
  'World Group I': t('tennis.world.group'),
  'World Group Play-offs': t('tennis.world.group.playoffs'),
};

const qualifyingPhases = ['Qualifying 1st Round', 'Qualifying 2nd Round', 'Qualifying 3rd Round', 'Qualifying Final']

export const isQualifyingPhase = (phase: string): boolean => {
  return qualifyingPhases.includes(phase);
}
